export default __webpack_public_path__ + "static/media/fw-emily-er-Rose Gold.aaff8421.mp4";